export default __webpack_public_path__ + "static/media/81111-loading-13.5ac8047f.gif";